// This is intentionally not generated using updateIndexes script
// Swagger will lazy load the SwaggerInner (which is large)
import _Swagger from './Swagger';
// import _SwaggerInner from './SwaggerInner';
// import * as stylesHold from './styles';
// export const styles = stylesHold;
export const Swagger = _Swagger;
//export const SwaggerInner = _SwaggerInner;
export default { Swagger /*, SwaggerInner */ };
